export const companyInfo = {
  name: "Meyer Management ApS",
  brand: "Pia Meyer",
  phone: "+45 22 86 35 55",
  email: "hej@piameyer.dk",
  cvr: "44382296",
  socials: {
    linkedin: "https://www.linkedin.com/in/pia-meyer-02b3927",
    facebook: "https://www.facebook.com/piameyer76/",
    instagram: "https://www.instagram.com/piameyer76/"
  }
};

export const servicesList = [
  { name: "Interim assistance i økonomifunktionen", href: "/ydelser#interim-assistance" },
  { name: "CFO sparring og udvikling", href: "/ydelser#cfo-sparring" },
  { name: "Teamudvikling og workshops", href: "/ydelser#teamudvikling-workshops" },
  { name: "Podcast", href: "/podcast" },
  { name: "Netværk", href: "/ydelser#netvaerk" }
];

export const navigation = [
  { name: "Forside", href: "/" },
  { 
    name: "Ydelser", 
    href: "/ydelser",
    children: servicesList
  },
  { name: "Om mig", href: "/om-mig" },
  { name: "Kontakt", href: "/kontakt" }
];

export const colors = {
  bg: "bg-[#f7f4ed]", // Lys creme / baggrund
  accent: "bg-[#3fbf6f]", // Grøn accent
  primary: "bg-[#2bc037]", // Supplerende grøn
  contrast: "text-[#1a1a1a]", // Sort / næsten sort tekst
  contrastBg: "bg-[#204f3d]", // Mørkegrøn
  gold: "text-[#204f3d]" // Mørkegrøn til ikoner/markeringer
};

export const testimonialsData = [
  {
    id: '632f8a93-bf63-4a8b-baab-8b2e85472c5e',
    name: 'Henning Kristiansen',
    role: 'Ejer Adminto ApS',
    quote: 'Vi har haft fornøjelsen af at samarbejde med Pia Meyer gennem flere opgaver på controller- og regnskabschefniveau hos vores kunder, og hun har hver gang leveret resultater af høj kvalitet. Pia er ikke bare fagligt skarp og struktureret – hun formår også at skabe værdi ud over tallene.\n\nHun træder ind i økonomiafdelinger som et frisk pust udefra, der hurtigt bliver en naturlig del af teamet og bidrager til både faglighed og god energi. Vores kunder har altid været meget tilfredse med hendes indsats, og samarbejdet har været en fornøjelse fra start til slut.\n\nVi giver Pia vores varmeste anbefaling – både som kompetent regnskabskonsulent og som et menneske, der gør en positiv forskel i enhver organisation, hun arbejder med.'
  }
];

export const servicesData = [
  {
    id: '1',
    title: 'Interim assistance i økonomifunktionen',
    path: 'interim-assistance',
    summary: 'Jeg træder til som en erfaren ressource, når I har brug for ekstra hænder eller specifikke kompetencer i en overgangsperiode.',
    benefits: 'Hurtig opstart\nFaglig tyngde\nRo i driften',
    price_info: 'Timepris aftales.',
    image: ['https://assets.auxodev.dk/assets/b8a7f302-f5bc-457e-a48c-e9d29dfda424/8db0f501-901d-4d2c-b520-508e9da7fa60.jpg']
  },
  {
    id: '2',
    title: 'CFO sparring og udvikling',
    path: 'cfo-sparring',
    summary: 'Strategisk sparring to økonomichefen eller ledelsen om optimering af økonomifunktionen og ledelse af teamet.',
    benefits: 'Strategisk overblik\nLedelsesmæssig sparring\nOptimering af processer',
    price_info: 'Timepris eller skræddersyet forløb aftales nærmere.',
    image: ['https://assets.auxodev.dk/assets/b8a7f302-f5bc-457e-a48c-e9d29dfda424/e3e0f413-06e4-4950-8909-c3f818dfff64.jpg']
  },
  {
    id: '3',
    title: 'Teamudvikling og workshops',
    path: 'teamudvikling-workshops',
    summary: 'Facilitering af processer der styrker samarbejdet, trivslen og den fælles retning i økonomiteamet.',
    benefits: 'Stærkere samarbejde\nFælles sprog\nBedre trivsel',
    price_info: 'Timepris eller skræddersyet forløb aftales nærmere.',
    image: ['https://assets.auxodev.dk/assets/b8a7f302-f5bc-457e-a48c-e9d29dfda424/16492717-557e-480c-a3c8-aba26a285ab3.jpg']
  },
  {
    id: '4',
    title: 'Podcast',
    path: 'podcast',
    summary: 'Inspirerende samtaler om ledelse, økonomi og det hele menneske. (Beskrivelse på vej)',
    benefits: '',
    price_info: 'Min podcast hedder: Menneskelig ledelse, kontakt mig hvis du har input til emner eller gerne vil deltage i et afsnit.',
    image: ['https://assets.auxodev.dk/assets/b8a7f302-f5bc-457e-a48c-e9d29dfda424/8db0f501-901d-4d2c-b520-508e9da7fa60.jpg']
  },
  {
    id: '5',
    title: 'Netværk',
    path: 'netvaerk',
    summary: 'Jeg vil gerne starte et netværk for kvindelige økonomiledere med menneskelig ledelse som drivkraft. Jeg kalder det Wingwomen.',
    benefits: '',
    price_info: 'Kontakt mig hvis du gerne vil deltage i dette.',
    image: ['https://assets.auxodev.dk/assets/b8a7f302-f5bc-457e-a48c-e9d29dfda424/e3e0f413-06e4-4950-8909-c3f818dfff64.jpg']
  }
];
